import React, { useEffect, useState } from "react";
import { getDatabase, ref, get, update } from "firebase/database";
import { useNavigate, useParams } from "react-router-dom";

export default function EditClientPage({ uid }) {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const db = getDatabase();

  const [form, setForm] = useState({
    fullName: "",
    phone: "",
    wilaya: "",
    commune: "",
    address: "",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [wilayas, setWilayas] = useState([]);
  const [communesMap, setCommunesMap] = useState({});

  // 🔹 تحميل JSON الولايات والبلديات
  useEffect(() => {
  fetch("/algeria_cities.json")
    .then((res) => res.json())
    .then((data) => {
      const wMap = {};
      const wList = [];

      data.forEach((item) => {
        const wilayaFr = item.wilaya_name_ascii;
        const communeFr = item.commune_name_ascii;

        if (!wMap[wilayaFr]) {
          wMap[wilayaFr] = [];
          wList.push(wilayaFr);
        }
        wMap[wilayaFr].push(communeFr);
      });

      setWilayas(wList);
      setCommunesMap(wMap);
    })
    .catch((err) => console.error("Erreur JSON:", err));
}, []);


  // 🔄 تحميل بيانات العميل من Firebase
 useEffect(() => {
  const clientRef = ref(db, `distributors/${uid}/clientsAdd/${clientId}`);
  get(clientRef).then((snapshot) => {
    if (snapshot.exists()) {
      const clientData = snapshot.val();

      // تحويل الولاية والبلدية للعربية إلى الفرنسية إذا كان JSON جاهز
      let wilayaFr = clientData.wilaya;
      let communeFr = clientData.commune;

      // إذا الـ JSON جاهز
      if (wilayas.length > 0 && Object.keys(communesMap).length > 0) {
        // ابحث عن wilaya الفرنسية المطابقة للاسم المخزن
        for (let w of wilayas) {
          if (communesMap[w].some(c => c === clientData.commune)) {
            wilayaFr = w;
            communeFr = clientData.commune;
            break;
          }
        }
      }

      setForm({
        ...clientData,
        wilaya: wilayaFr || "",
        commune: communeFr || "",
      });
    } else {
      alert("العميل غير موجود");
      navigate("/clients");
    }
    setLoading(false);
  });
}, [uid, clientId, db, navigate, wilayas, communesMap]);


  // 💾 حفظ التعديلات
  const saveClient = async () => {
    if (!form.fullName || !form.phone || !form.wilaya || !form.commune) {
      alert("الرجاء تعبئة جميع الحقول المطلوبة");
      return;
    }

    setSaving(true);
    try {
      await update(ref(db, `distributors/${uid}/clientsAdd/${clientId}`), form);
      alert("تم تحديث بيانات العميل بنجاح ✅");
      navigate("/clients");
    } catch (err) {
      alert("حدث خطأ أثناء الحفظ");
      console.error(err);
    }
    setSaving(false);
  };

  if (loading) return <div>⏳ تحميل بيانات العميل...</div>;

  return (
    <div style={{ maxWidth: 450, margin: "auto" }}>
      <h2 style={{ textAlign: "center" }}>✏️ Modifier le client</h2>

      {/* الاسم الكامل */}
      <input
        placeholder="الاسم الكامل"
        value={form.fullName}
        onChange={(e) => setForm({ ...form, fullName: e.target.value })}
        style={{ width: "100%", padding: 10, marginBottom: 12, borderRadius: 6, border: "1px solid #ccc" }}
      />

      {/* رقم الهاتف */}
      <input
        placeholder="رقم الهاتف"
        value={form.phone}
        onChange={(e) => setForm({ ...form, phone: e.target.value })}
        style={{ width: "100%", padding: 10, marginBottom: 12, borderRadius: 6, border: "1px solid #ccc" }}
      />

      {/* Dropdown الولاية */}
      <select
        value={form.wilaya}
        onChange={(e) => setForm({ ...form, wilaya: e.target.value, commune: "" })}
        style={{ width: "100%", padding: 10, marginBottom: 12, borderRadius: 6, border: "1px solid #ccc" }}
      >
        <option value="">-- اختر الولاية --</option>
        {wilayas.map((w) => (
          <option key={w} value={w}>{w}</option>
        ))}
      </select>

      {/* Dropdown البلدية */}
      <select
        value={form.commune}
        onChange={(e) => setForm({ ...form, commune: e.target.value })}
        style={{ width: "100%", padding: 10, marginBottom: 12, borderRadius: 6, border: "1px solid #ccc" }}
        disabled={!form.wilaya}
      >
        <option value="">-- اختر البلدية --</option>
        {form.wilaya && communesMap[form.wilaya]?.map((c) => (
          <option key={c} value={c}>{c}</option>
        ))}
      </select>

      {/* العنوان */}
      <input
        placeholder="العنوان"
        value={form.address}
        onChange={(e) => setForm({ ...form, address: e.target.value })}
        style={{ width: "100%", padding: 10, marginBottom: 12, borderRadius: 6, border: "1px solid #ccc" }}
      />

      {/* زر الحفظ */}
      <button
        onClick={saveClient}
        disabled={saving}
        style={{
          width: "100%",
          padding: 12,
          background: saving ? "#94a3b8" : "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: 8,
          cursor: saving ? "not-allowed" : "pointer",
        }}
      >
        {saving ? "⏳ جاري الحفظ..." : "💾 Sauvegarder"}
      </button>
    </div>
  );
}
